<template>
  <OmtStickedModal v-if="isOpen" @close="close" data-cy="refund-create-terms-modal">
    <OmtRow>
      <OmtTypography as="h1-bold" lineHeight="32px"> ATENÇÃO </OmtTypography>
    </OmtRow>
    <OmtRow mt="16px">
      <OmtTypography as="p1" lineHeight="22px">
        O recibo deve conter o nome completo, o CPF e o número de registro no Conselho de Classe do profissional.
      </OmtTypography>
    </OmtRow>
    <OmtRow mt="8px">
      <OmtTypography as="p1" lineHeight="22px">
        Antes de enviar, certifique-se de que todas essas informações estão corretamente preenchidas.
      </OmtTypography>
    </OmtRow>
    <OmtRow mt="8px">
      <OmtTypography as="p1" lineHeight="22px">
        Caso algum dado esteja faltando, ele pode ser fornecido por meio de uma declaração complementar emitida pelo
        próprio profissional.
      </OmtTypography>
    </OmtRow>
    <OmtRow mt="8px">
      <OmtTypography as="p1" lineHeight="22px">
        <strong>Lembre-se:</strong> os documentos fiscais aceitos por este canal são: Recibos digitais emitidos conforme
        a IN nº 2.240/24 e Notas Fiscais Eletrônicas.
      </OmtTypography>
    </OmtRow>
    <template #footer>
      <OmtButton w="100%" @click="save"> Entendi </OmtButton>
    </template>
  </OmtStickedModal>
</template>

<script>
/**
 * @prop {Boolean} isOpen
 */
export default {
  props: {
    isOpen: {
      Type: Boolean
    }
  },
  methods: {
    close() {
      this.$emit("update:isOpen", false);
    },
    save() {
      this.$emit("continue");
      this.close();
    }
  }
};
</script>
